import {
  featuredStoreReviewListQuery,
  HYDRATED_QUERY_OPTIONS,
} from '@/lib/page-queries';
import { useQuery } from '@tanstack/react-query';
import { ApiResponse, QUERY_KEYS } from '../base-api';
import { getStoreReviewList } from '../store-review.service';
import { SiteCategory } from '../types/globals.type';
import {
  GetStoreReviewListParams,
  StoreReviewEntity,
  StoreReviewListResponse,
} from '../types/store-review.type';

export const useFeaturedStoreReviewList = (category?: SiteCategory) => {
  return useQuery<ApiResponse<StoreReviewEntity[]>>({
    ...featuredStoreReviewListQuery(category),
    ...HYDRATED_QUERY_OPTIONS,
  });
};

// export const useStoreReviewList = (storeId: number) => {
//   return useQuery<ApiResponse<StoreReviewEntity[]>>({
//     queryKey: [QUERY_KEYS.STORE_REVIEW, QUERY_KEYS.LIST, storeId],
//     queryFn: () => getStoreReviewList(storeId),
//     enabled: !!storeId,
//   });
// };

export const useStoreReviewList = (params: GetStoreReviewListParams) => {
  return useQuery<ApiResponse<StoreReviewListResponse>>({
    queryKey: [QUERY_KEYS.STORE_REVIEW, QUERY_KEYS.LIST, params],
    queryFn: () => getStoreReviewList(params),
    enabled: !!params?.storeId,
  });
};
